import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useProductList } from '@/hooks/useProductList';
// SaleSmartly 游客自动弹窗（暂时停用，保留以便恢复）
// import { useEffect } from 'react';
// import { getToken } from '@/lib/auth-storage';
// import {
//   HOME_GUEST_WELCOME_DELAY_MS,
//   hasShownHomeGuestWelcome,
//   markHomeGuestWelcomeShown,
//   openSaleSmartlyGuestWelcome,
// } from '@/lib/salesmartly';
import HeroSection from './components/HeroSection';
import HotServices from './components/HotServices';
import HowToQuery from './components/HowToQuery';
import Testimonials from './components/Testimonials';
import AffiliateSection from './components/AffiliateSection';

export default function HomePage() {
  const { products, loading, error } = useProductList();

  // SaleSmartly：未登录首页 8 秒自动弹客服（Chatwoot 期已停用）
  // useEffect(() => {
  //   const hasToken = Boolean(getToken());
  //   const alreadyShown = hasShownHomeGuestWelcome();
  //   if (hasToken) {
  //     return;
  //   }
  //   if (alreadyShown) {
  //     return;
  //   }
  //   const timer = window.setTimeout(() => {
  //     const stillLoggedIn = Boolean(getToken());
  //     const shownNow = hasShownHomeGuestWelcome();
  //     if (stillLoggedIn || shownNow) {
  //       return;
  //     }
  //     markHomeGuestWelcomeShown();
  //     openSaleSmartlyGuestWelcome();
  //   }, HOME_GUEST_WELCOME_DELAY_MS);
  //   return () => {
  //     window.clearTimeout(timer);
  //   };
  // }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <HotServices products={products} loading={loading} error={error} />
        <HowToQuery />
        <Testimonials products={products} />
        <AffiliateSection />
      </main>
      <Footer />
    </div>
  );
}
